import { FC } from "react";
import { GenericAppThemeProperty } from "../Types";
import ColorPropertyCard from "../Cards/ColorPropertyCard";
import { Grid } from "@material-ui/core";

type ColorPropertiesListProps = {
  propertiesList: GenericAppThemeProperty[];
  isDarkFilter: boolean;
};

const ColorPropertiesList: FC<ColorPropertiesListProps> = ({ propertiesList, isDarkFilter }) => {
  const filteredProps = propertiesList.filter(x => x.isDark === isDarkFilter).sort(x => x.sortOrder);

  return (
    <>
      <Grid container spacing={1} sx={{ padding: '1%' }}>
        {filteredProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={property.themePropertyKey}>
            <ColorPropertyCard property={property} key={property.themePropertyKey} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ColorPropertiesList;